import { useLocation, useNavigate } from "react-router-dom";
import { Home, Users, Calendar, CalendarDays, ShoppingBag, Settings } from "lucide-react";

const navItems = [
  { path: "/dashboard", icon: Home, label: "Home" },
  { path: "/calendar", icon: CalendarDays, label: "Calendario" },
  { path: "/services", icon: Users, label: "Servizi" },
  { path: "/shop", icon: ShoppingBag, label: "Shop" },
  { path: "/settings", icon: Settings, label: "Altro" },
];

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 bg-white dark:bg-[#1C1C1E] backdrop-blur-xl border-t border-black/5 dark:border-white/10 py-2 px-6 flex justify-around items-center z-50 lg:hidden" 
      style={{ paddingBottom: 'max(0.5rem, env(safe-area-inset-bottom))' }}
      data-testid="bottom-nav"
    >
      {navItems.map((item) => {
        const isActive = location.pathname === item.path || 
          (item.path === "/dashboard" && location.pathname.startsWith("/pets"));
        const Icon = item.icon;
        
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center gap-1 py-2 px-4 rounded-xl transition-all ${
              isActive 
                ? 'text-[#FF6B4A]' 
                : 'text-[#86868B] dark:text-white/60 hover:text-[#FF6B4A] hover:bg-[#FF6B4A]/5'
            }`}
            data-testid={`nav-${item.label.toLowerCase()}`}
          >
            <Icon 
              size={22} 
              strokeWidth={isActive ? 2.5 : 1.8}
              className="transition-all"
              fill={isActive ? "currentColor" : "none"}
            />
            <span className="text-[10px] font-medium tracking-tight">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
